<template>
  <v-container
    id="detalhe-melhores-clientes-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row v-if="!paginaEnable">
      <h1>
        Usuário não tem permissão a essa página não existente
      </h1>
    </v-row>
    <v-row v-else>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <v-row>
          <v-col
            cols="12"
            class="container"
          >
            <v-container>
              <dashboard-filtro-datas
                :primeiro="enablePrimeiroDia"
                :ultimo="enableUltimoDia"
                :empresas="enableEmpresa"
                :vendedores="enableVendedor"
                :supervisores="enableSupervisor"
                :areas="enableArea"
                :redes="enableRede"
                :receitas="enableReceita"
                :segmentos="enableSegmento"
              />
            </v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <div>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <v-card
                        id="cardDashbord"
                        class="mx-auto"
                        outlined
                      >
                        <div class="card-header-dashbord">
                          <v-row>
                            <v-col
                              cols="12"
                              sm="9"
                              md="9"
                              lg="9"
                              class="d-flex flex-wrap"
                            >
                              Qual o perfil do MIX comprado?
                            </v-col>
                            <v-col
                              cols="12"
                              sm="1"
                              md="1"
                              lg="1"
                              class="d-flex justify-end"
                            >
                              <v-btn
                                id="btnPrint"
                                class="col-12 lg-12"
                                small
                                :disabled="enableBtn"
                                :color="corPrimaria"
                                dark
                                @click="imprimir()"
                              >
                                <v-icon>
                                  mdi-printer
                                </v-icon>
                                Imprimir
                              </v-btn>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="2"
                              md="2"
                              lg="2"
                              class="d-flex justify-end"
                            >
                              <v-tooltip top>
                                <template
                                  v-slot:activator="{ on, attrs }"
                                >
                                  <v-icon
                                    id="iconInformationMelhoresClientes"
                                    class="text-left"
                                    v-bind="attrs"
                                    v-on="on"
                                    @mouseover="enableTexto('332')"
                                  >
                                    mdi-information-outline
                                  </v-icon>
                                </template>
                                <div
                                  v-if="codigo === '332'"
                                  v-html="textoDetalhesClienteMixComercializado"
                                />
                              </v-tooltip>
                            </v-col>
                          </v-row>
                        </div>
                        <v-card-actions>
                          <v-row>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                              lg="12"
                            >
                              <div
                                v-if="loading"
                                :style="styleObject"
                                class="text-center"
                              >
                                <v-icon
                                  light
                                  class="custom-loader"
                                  :style="styleObject"
                                >
                                  mdi-cached
                                </v-icon>
                                Carregando dados...
                              </div>
                              <div
                                v-else-if="error"
                                class="alert alert-danger"
                              >
                                {{ error }}
                              </div>
                              <div v-else>
                                <v-row
                                  id="filtrosPrint"
                                  class="hidden"
                                >
                                  <v-col
                                    cols="12"
                                    sm="12"
                                    md="12"
                                    lg="12"
                                  >
                                    <h3 class="text-center">
                                      Filtros Selecionados:
                                    </h3>
                                    <div class="text-center">
                                      Data Inicial: {{ dataInicialImpressao }}
                                    </div>
                                    <div class="text-center">
                                      Data Final: {{ dataFinalImpressao }}
                                    </div>
                                    <v-row>
                                      <v-col
                                        v-if="select.length > 0"
                                        cols="12"
                                        sm="4"
                                        md="4"
                                        lg="4"
                                      >
                                        <div
                                          class="'text-center'"
                                        >
                                          Empresas selecionadas:
                                          <ul class="no-list-style">
                                            <li
                                              v-for="empresa in select"
                                              :key="empresa"
                                            >
                                              {{ empresa.nomeExibicao }}
                                            </li>
                                          </ul>
                                        </div>
                                      </v-col>
                                      <v-col
                                        v-if="vendedorSelect.length > 0"
                                        cols="12"
                                        sm="4"
                                        md="4"
                                        lg="4"
                                      >
                                        <div
                                          class="'text-center'"
                                        >
                                          Vendedores selecionados:
                                          <ul class="no-list-style">
                                            <li
                                              v-for="vendedor in vendedorSelect"
                                              :key="vendedor"
                                            >
                                              {{ vendedor }}
                                            </li>
                                          </ul>
                                        </div>
                                      </v-col>
                                      <v-col
                                        v-if="selectCliente.length > 0"
                                        cols="12"
                                        sm="4"
                                        md="4"
                                        lg="4"
                                      >
                                        <div
                                          class="'text-center'"
                                        >
                                          Clientes selecionados:
                                          <ul class="no-list-style">
                                            <li
                                              v-for="cliente in selectCliente"
                                              :key="cliente"
                                            >
                                              {{ cliente.cliente }}
                                            </li>
                                          </ul>
                                        </div>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                                <!-- Tabela principal Inicio -->
                                <div
                                  id="idTable"
                                  style="overflow-x: auto;"
                                >
                                  <table
                                    style="width: 100%; color: black; border-collapse: collapse;"
                                    class="elevation-1"
                                    mobile-breakpoint="0"
                                  >
                                    <thead>
                                      <tr>
                                        <th
                                          id="dadoMovimentacaoHeader"
                                          style="text-align: center;"
                                          class="black--text title"
                                        >
                                          Cliente
                                        </th>
                                        <th
                                          id="dadoMovimentacaoHeader"
                                          style="text-align: center;"
                                          class="black--text title"
                                        >
                                          Produto
                                        </th>
                                        <th
                                          id="dadoMovimentacaoHeader"
                                          style="text-align: center;"
                                          class="black--text title"
                                        >
                                          Faturamento
                                        </th>
                                        <th
                                          id="dadoMovimentacaoHeader"
                                          style="text-align: center;"
                                          class="black--text title"
                                        >
                                          Quantidade
                                        </th>
                                        <th
                                          id="dadoMovimentacaoHeader"
                                          style="text-align: center;"
                                          class="black--text title"
                                        >
                                          Preço méd. produtos
                                        </th>
                                        <th
                                          id="dadoMovimentacaoHeader"
                                          style="text-align: center;"
                                          class="black--text title"
                                        >
                                          Variação pre. anual
                                        </th>
                                        <th
                                          id="dadoMovimentacaoHeader"
                                          style="text-align: center;"
                                          class="black--text title"
                                        >
                                          ABC de grupos
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        v-for="item in dadosDetalhamento"
                                        :key="item.id"
                                      >
                                        <td
                                          id="dadoMovimentacao"
                                          style="text-align: left;"
                                        >
                                          {{ item.cliente }}
                                        </td>
                                        <td
                                          id="dadoMovimentacao"
                                          style="text-align: left;"
                                        >
                                          {{ item.grupo_produto }}
                                        </td>
                                        <td
                                          id="dadoMovimentacao"
                                          style="text-align: right;"
                                        >
                                          {{ item.faturamento }}
                                        </td>
                                        <td
                                          id="dadoMovimentacao"
                                          style="text-align: right;"
                                        >
                                          {{ item.quantidade }}
                                        </td>
                                        <td
                                          id="dadoMovimentacao"
                                          style="text-align: right;"
                                        >
                                          {{ item.preco_medido }}
                                        </td>
                                        <td
                                          id="dadoMovimentacao"
                                          style="text-align: right;"
                                        >
                                          {{ item.variacao_anual }}
                                        </td>
                                        <td
                                          id="dadoMovimentacao"
                                          style="text-align: right;"
                                        >
                                          {{ item.abc_grupo }}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import eventEmit from '../../../components/core/EventoEmit'
  import Cliente from '../../../../../services/somentecliente'

  export default {
    name: 'DashboardExtratoClienteMixComercializadoDetalhamento',
    emits: ['atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../../components/core/Snackbar'),
      DashboardFiltroDatas: () => import('../../../components/core/FiltroDatas'),
    },

    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObjectIcon: {
        color: '#4780b8',
      },
      valorReceber: localStorage.valorReceber,
      valorVencido: 0,
      paginaEnable: false,
      permissaoContasReceber: '',
      primeiroDia: (new Date(localStorage.dataInicial)).toISOString().substr(0, 10),
      ultimoDia: (new Date(localStorage.dataFinal)).toISOString().substr(0, 10),
      enableEmpresa: true,
      enableVendedor: true,
      enableSupervisor: true,
      enableArea: true,
      enableRede: true,
      enableReceita: true,
      enableSegmento: true,
      select: [],
      vendedorSelect: [],
      areaSelect: [],
      redeSelect: [],
      supervisorSelect: [],
      receitaIds: [],
      segmento: [],
      selectCategoria: [],
      selectPromotor: [],
      selectClassificacao: [],
      selectCliente: [],
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      link: localStorage.linkClientes,
      menu: false,
      menu1: false,
      dataInicialImpressao: false,
      dataFinalImpressao: false,
      codigo: 0,
      orientacao: [],
      textoDetalhesClienteMixComercializado: '',
      headersMixComprado: [
        { text: 'Cliente', value: 'cliente', width: '180px', class: 'black--text title' },
        { text: 'Produto', value: 'grupo_produto', width: '200px', class: 'black--text title' },
        { text: 'Faturamento', value: 'faturamento', width: '120px', align: 'right', class: 'black--text title' },
        { text: 'Quantidade', value: 'quantidade', width: '120px', align: 'right', class: 'black--text title' },
        { text: 'Preço méd. produtos', value: 'preco_medido', width: '120px', align: 'right', class: 'black--text title' },
        { text: 'Variação pre. anual', value: 'variacao_anual', width: '120px', align: 'right', class: 'black--text title' },
        { text: 'ABC de grupos', value: 'abc_grupo', width: '120px', align: 'right', class: 'black--text title' },
      ],
      dadosDetalhamento: [],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      enableBtn: true,
      loading: false,
      error: null,
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.ultimoDia)
      },

      computedPrimeiroDia () {
        return this.formatDatePrimeiroDia(this.primeiroDia)
      },

      likesAllCliente () {
        return this.selectCliente.length === this.clientes.length
      },
      likesSomeCliente () {
        return this.selectCliente.length > 0 && !this.likesAllCliente
      },
      icon () {
        if (this.likesAllCliente) return 'mdi-close-box'
        if (this.likesSomeCliente) return 'mdi-minus-box'
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.enableConsulta = false
        return 'mdi-checkbox-blank-outline'
      },
    },

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        this.usuarioIdentificado = true

        this.paginaEnable = true

        this.orientacao = JSON.parse(localStorage.getItem('orientacaoCliente'))

        Cliente.showDadosCliente(localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            for (var i = 0; i < resposta.data.dadosClientes.length; i++) {
              this.clientes.push(resposta.data.dadosClientes[i])
            }
          } else if (resposta.data.msg === 'Não há clientes cadastrados') {
            this.clientes = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })

        eventEmit.$emit('atualizar_texto', 'Cliente')
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, vendedor, area, rede, supervisor, receita, segmento) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select
        this.vendedorSelect = vendedor
        this.areaSelect = area
        this.redeSelect = rede
        this.supervisorSelect = supervisor
        this.receita = receita
        this.segmento = segmento

        localStorage.setItem('updateDadosFiltros', true)
        localStorage.setItem('dataInicial', this.primeiroDia)
        localStorage.setItem('dataFinal', this.ultimoDia)
        localStorage.setItem('empresaId', JSON.stringify(this.select || []))

        this.updateDate()
      },

      toggle () {
        this.$nextTick(() => {
          if (this.likesAllCliente) {
            this.selectCliente = []
          } else {
            if (this.filterClientes.length > 0) {
              this.selectCliente = this.filterClientes
            } else {
              this.selectCliente = this.clientes.slice()
            }
          }
        })
      },

      filter () {
        if (this.filtro.length > 0) {
          for (let i = 0; i < this.clientes.length; i++) {
            if (this.clientes[i].cliente.toLowerCase().includes(this.filtro.toLowerCase())) {
              this.filterClientes.push(this.clientes[i])
            }
          }
        } else {
          this.filterClientes = []
        }
      },

      formatDate (date) {
        if (!date) {
          return null
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePrimeiroDia (date) {
        if (!date) {
          return null
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      enableTexto (value) {
        var i = 0

        this.codigo = value

        for (i in this.orientacao) {
          if (this.orientacao[i].codigo === '332') {
            this.textoDetalhesClienteMixComercializado = this.orientacao[i].descricao
          }
        }
      },

      updateDate () {
        this.dadosDetalhamento = []

        this.formatarDatasImpressao()

        this.showDelhamentoExtratoSomenteClienteMixComercializado()
      },

      imprimir () {
        var filtros = document.getElementById('filtrosPrint').innerHTML
        var conteudo = document.getElementById('headersMixComprado').innerHTML

        var telaImpressao = window.open('', '_blank')

        var impressao = filtros + conteudo

        telaImpressao.document.write(impressao)
        telaImpressao.window.print()
        telaImpressao.window.close()
      },

      formatarDatasImpressao () {
        var partesInicial = this.primeiroDia.split('-')
        var ano = partesInicial[0]
        var mes = partesInicial[1]
        var dia = partesInicial[2]
        this.dataInicialImpressao = dia + '/' + mes + '/' + ano

        var partesFinal = this.ultimoDia.split('-')
        var anoFinal = partesFinal[0]
        var mesFinal = partesFinal[1]
        var diaFinal = partesFinal[2]
        this.dataFinalImpressao = diaFinal + '/' + mesFinal + '/' + anoFinal
      },

      showDelhamentoExtratoSomenteClienteMixComercializado () {
        this.loading = true
        this.enableBtn = true

        Cliente.showExtratoSomenteClienteMixComercializado(this.primeiroDia, this.ultimoDia, this.selectCliente, this.select, this.vendedorSelect, localStorage.tokencontrato, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receitaSelect).then(resposta => {
          if (resposta.data.status) {
            this.enableBtn = false

            this.dadosDetalhamento = resposta.data.mixComprado.map((item) => {
              var listaDetalhamento = ({
                cliente: item.cliente,
                grupo_produto: item.grupo_produto,
                faturamento: item.faturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                quantidade: item.quantidade,
                preco_medido: item.preco_medido.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                variacao_anual: item.variacao_anual + '%',
                abc_grupo: item.abc_grupo + '%',
              })

              return listaDetalhamento
            })
          } else if (resposta.data.msg === 'Não há dados para o período selecionado') {
            this.dadosDetalhamento = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false
        })
      },

      getColor (value) {
        var porcentagem = parseFloat(value.replace(',', '.'))

        if (porcentagem >= 100) {
          return 'color: green'
        } else {
          return 'color: red'
        }
      },
    },
  }
</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
    }

    #dadoMovimentacao {
      font-size: 8.5px !important;
    }

    th, td {
      padding: 8px;
    }
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 600px;
  }

   #dadoMovimentacao {
    font-size: 12px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }
</style>

<style lang="sass">

  .no-list-style
    list-style-type: none
    padding: 0
    margin: 0

  .no-list-style li
    text-decoration: none

  .hidden
    display: none

  #relatorioMelhoresClientesFaturados
    margin-left: 0.5rem
    font-size: 14px
    font-weight: bold

  #iconInformationMelhoresClientes
    margin-left: 9.5rem
    font-weight: bold

  #headersClientesFaturados
    margin-left: 1.7rem
    margin-right: 1.7rem

  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

</style>
